"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LogEvent;

var _react = _interopRequireDefault(require("react"));

var _lodash = require("lodash");

var _Log = _interopRequireWildcard(require("./Log"));

var _clevertap = require("../utils/clevertap");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getEventHandlers(child, consumedProps, actionProps) {
  var eventHandlers = {};
  (0, _lodash.forEach)(actionProps, function (specificHandlerProps, eventHandlerName) {
    eventHandlers[eventHandlerName] = function () {
      var _child$props$eventHan;

      (0, _clevertap.event)(consumedProps.eventName, _objectSpread({}, consumedProps));

      for (var _len = arguments.length, eventHandlerArgs = new Array(_len), _key = 0; _key < _len; _key++) {
        eventHandlerArgs[_key] = arguments[_key];
      }

      (_child$props$eventHan = child.props[eventHandlerName]) === null || _child$props$eventHan === void 0 ? void 0 : _child$props$eventHan.apply(child, eventHandlerArgs);
    };
  });
  return eventHandlers;
}

function LogEvent(props) {
  var actionProps = props.actionProps,
      logEventProps = props.logEventProps,
      children = props.children;

  if (!logEventProps || !actionProps) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
  }

  return /*#__PURE__*/_react["default"].createElement(_Log["default"], logEventProps, /*#__PURE__*/_react["default"].createElement(_Log.LogContext.Consumer, null, function (consumedProps) {
    return _react["default"].Children.map(children, function (child) {
      return /*#__PURE__*/_react["default"].cloneElement(child, getEventHandlers(child, consumedProps, actionProps));
    });
  }));
}